import AbstractCustomerValueModel from '../abstract_customer_value_model';
import BenefitsChartValue from '../../charts/benefits_chart_value';
import BenefitsWaterfallChart from '../../charts/symplr/benefits_waterfall_chart';

class SymplrCvo extends AbstractCustomerValueModel {
  custom_chart_classes() {
    return { BenefitsChartValue, BenefitsWaterfallChart };
  }

  percent_rdxn_credentialing_time() {
    return this.input.percent_rdxn_credentialing_time / 100;
  }

  percent_rdxn_enrolling_time() {
    return this.input.percent_rdxn_enrolling_time / 100;
  }

  percent_rdxn_recredentialing_time() {
    return this.input.percent_rdxn_recredentialing_time / 100;
  }

  percent_rdxn_psv_time() {
    return this.input.percent_rdxn_psv_time / 100;
  }

  percent_rdxn_pev_time() {
    return this.input.percent_rdxn_pev_time / 100;
  }

  adoption_rate_year_1() {
    return this.input.adoption_rate_year_1 / 100;
  }

  adoption_rate_year_2() {
    return this.input.adoption_rate_year_2 / 100;
  }

  adoption_rate_year_3() {
    return this.input.adoption_rate_year_3 / 100;
  }

  adoption_rate_year_4() {
    return this.input.adoption_rate_year_4 / 100;
  }

  adoption_rate_year_5() {
    return this.input.adoption_rate_year_5 / 100;
  }

  adoption_rate(year) {
    switch (year) {
      case 1: return this.adoption_rate_year_1();
      case 2: return this.adoption_rate_year_2();
      case 3: return this.adoption_rate_year_3();
      case 4: return this.adoption_rate_year_4();
      case 5: return this.adoption_rate_year_5();
      default: return 1.0;
    }
  }

  annual_med_staff_salary() {
    return this.input.annual_med_staff_salary;
  }

  annual_price_increase(year) {
    return (1 + (this.input.annual_increase / 100)) ** (year - 1);
  }

  burden_rate() {
    return this.input.burden_rate;
  }

  credentialing_psv_timeline() {
    return this.input.credentialing_psv_timeline;
  }

  fte_doing_credentialing() {
    return this.input.fte_doing_credentialing;
  }

  fte_doing_enrolling() {
    return this.input.fte_doing_enrolling;
  }

  fte_doing_recredentialing() {
    return this.input.fte_doing_recredentialing;
  }

  fully_burdened_salary(salary) {
    return salary * this.burden_rate();
  }

  hours_per_year() {
    return 1880;
  }

  implementation_fee() {
    return this.input.implementation_fee;
  }

  payer_enrollment_timeline() {
    return this.input.payer_enrollment_timeline;
  }

  pes_license_fee() {
    return this.input.pes_license_fee;
  }

  practitioners_for_enrollment() {
    return this.input.practitioners_for_enrollment;
  }

  practitioners_for_initial_credential() {
    return this.input.practitioners_for_initial_credential;
  }

  practitioners_for_recredential() {
    return this.input.practitioners_for_recredential;
  }

  product_pes() {
    return this.input.product_pes;
  }

  product_psv() {
    return this.input.product_psv;
  }

  psv_license_fee() {
    return this.input.psv_license_fee;
  }

  revenue_per_provider() {
    return this.input.revenue_per_provider;
  }

  time_on_credentialing() {
    return 40;
  }

  time_on_enrolling() {
    return 40;
  }

  weeks_per_year() {
    return 52;
  }

  // Benefit 1
  reduce_time_credentialing() {
    // =(H9*Configurator!$G$49)*H11*(H12/Configurator!$G$51)
    if (this.product_psv() === 0) { return 0; }

    return (this.time_on_credentialing() * this.weeks_per_year()) * this.fte_doing_credentialing()
      * (this.fully_burdened_salary(this.annual_med_staff_salary()) / this.hours_per_year())
    * this.percent_rdxn_credentialing_time();
  }

  // Benefit 2
  reduce_time_enrolling() {
    // =(H25*Configurator!$G$49)*H27*(H28/Configurator!$G$51)
    if (this.product_pes() === 0) { return 0; }

    return (this.time_on_enrolling() * this.weeks_per_year()) * this.fte_doing_enrolling()
      * (this.fully_burdened_salary(this.annual_med_staff_salary()) / this.hours_per_year())
    * this.percent_rdxn_enrolling_time();
  }

  // Benefit 3
  reduce_time_recredentialing() {
    // =(H41*Configurator!$G$49)*H43*('Benefit Calculations'!H44/Configurator!$G$51)
    if (this.product_psv() === 0) { return 0; }

    return (this.time_on_enrolling() * this.weeks_per_year()) * this.fte_doing_recredentialing()
      * (this.fully_burdened_salary(this.annual_med_staff_salary()) / this.hours_per_year())
    * this.percent_rdxn_recredentialing_time();
  }

  // Benefit 4
  increase_revenue_pes() {
    if (this.product_pes() === 0) { return 0; }

    // =H76*H78*H79*H80
    return this.practitioners_for_enrollment() * this.revenue_per_provider() * 0.2
      * this.payer_enrollment_timeline()
    * this.percent_rdxn_pev_time();
  }

  increase_revenue_psv() {
    // =H69*H71*H72*H73
    if (this.product_psv() === 0) { return 0; }

    return this.credentialing_psv_timeline() * this.revenue_per_provider() * 0.2
      * this.practitioners_for_initial_credential()
    * this.percent_rdxn_psv_time();
  }

  increase_revenue() {
    return this.increase_revenue_psv() + this.increase_revenue_pes();
  }

  all_benefits() {
    return [
      'reduce_time_credentialing',
      'reduce_time_enrolling',
      'reduce_time_recredentialing',
      'increase_revenue'
    ];
  }

  value_drivers() {
    return [
      'streamline_healthcare_operations',
      'grow_protect_revenue'
    ];
  }

  streamline_healthcare_operations() {
    return this.reduce_time_credentialing()
      + this.reduce_time_enrolling()
      + this.reduce_time_recredentialing();
  }

  grow_protect_revenue() {
    return this.increase_revenue();
  }

  total_annual_investment(year = 1) {
    let cost = 0;

    if (this.product_psv() === 1) {
      cost += this.psv_license_fee();
    }

    if (this.product_pes() === 1) {
      cost += this.pes_license_fee();
    }

    if (year === 1) {
      cost += this.implementation_fee();
    }

    return cost * this.annual_price_increase(year);
  }

  streamline_healthcare_operations_label() {
    return this.input.streamline_healthcare_operations_label;
  }

  grow_protect_revenue_label() {
    return this.input.grow_protect_revenue_label;
  }

  reduce_time_credentialing_label() {
    return this.input.reduce_time_credentialing_label;
  }

  reduce_time_enrolling_label() {
    return this.input.reduce_time_enrolling_label;
  }

  reduce_time_recredentialing_label() {
    return this.input.reduce_time_recredentialing_label;
  }

  increase_revenue_label() {
    return this.input.increase_revenue_label;
  }
}

export default SymplrCvo;
